import { render, staticRenderFns } from "./createPedidos.vue?vue&type=template&id=27abcb10&scoped=true&"
import script from "./createPedidos.vue?vue&type=script&lang=js&"
export * from "./createPedidos.vue?vue&type=script&lang=js&"
import style0 from "./createPedidos.vue?vue&type=style&index=0&id=27abcb10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27abcb10",
  null
  
)

export default component.exports